import styled from "@emotion/styled";

const Layout = styled.section``;

Layout.Container = styled.div`
  height: 100%;
  background: black url(${({ backgroundImage }) => backgroundImage});
  background-repeat: no-repeat;
  background-position: center center;
`;

Layout.Content = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  color: white;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 80px);
`;

Layout.ImageCover = styled.div`
  width: 100%;
  top: 80px;
  height: calc(100% - 80px);
  position: absolute;
  background: rgb(0, 0, 0);
  opacity: 0.5;
`;

Layout.Header = styled.header`
  height: 80px;
  background-color: #5b6167;
  border-bottom-color: rgb(106, 113, 136);
  border-bottom-width: 1px;
`;

Layout.HeaderContent = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 30px;
`;

Layout.Title = styled.h1`
  font-size: 22px;
  color: white;
  font-weight: bold;
`;

Layout.HeroTitle = styled.h2`
  font-size: 64px;
  font-weight: bold;
`;

Layout.HeroDescription = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 174px;
`;

Layout.Menu = styled.div`
  display: flex;
  align-items: center;
  fill: white;
  color: white;
  gap: 32px;
`;

Layout.PhoneButton = styled.button`
  text-transform: uppercase;
  line-height: 2.2;
  font-variant: normal;
  border-radius: 4px;
  font-size: 14px;
  border: solid 2px white;
  padding: 4px 26px;
  tab-index: -1;
  pointer-events: none;
  cursor: pointer;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
`;

Layout.CTA = styled.button`
  background: #d04400;
  border-radius: 4px;
  padding: 6px 32px;
  font-weight: bold;
  width: 166px;
`;

export default Layout;
